export function formatInventoryDelta(delta, { suffix = "", invert = false } = {}) {
  const value = Number(delta) || 0;
  if (value === 0) {
    return { text: `No change${suffix ? ` ${suffix}` : ""}`, tone: "neutral" };
  }

  const improved = invert ? value < 0 : value > 0;
  const sign = value > 0 ? "+" : "";

  return {
    text: `${sign}${value}${suffix}`,
    tone: improved ? "positive" : "negative",
  };
}

export function formatPublicReadyProgress(progress, periodDays = 7) {
  if (!progress?.hasBaseline) {
    return {
      text: `Tracking starts after ${periodDays} days of snapshots`,
      tone: "neutral",
    };
  }

  const delta = progress.publicReadyPct?.delta ?? 0;
  const formatted = formatInventoryDelta(delta, { suffix: " pts" });
  return {
    text: `${formatted.text} vs ${periodDays} days ago`,
    tone: formatted.tone,
  };
}

export function formatIssueProgress(issueProgress, periodDays = 7, hasBaseline = true) {
  if (!issueProgress || !hasBaseline) return null;
  const delta = issueProgress.delta ?? 0;
  const formatted = formatInventoryDelta(delta, { invert: true });
  return {
    text: `${formatted.text} vs ${periodDays} days ago`,
    tone: formatted.tone,
  };
}
